import { render, staticRenderFns } from "./TheCertificateSearch.vue?vue&type=template&id=c5e61f4a"
import script from "./TheCertificateSearch.vue?vue&type=script&lang=js"
export * from "./TheCertificateSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports